/* import __COLOCATED_TEMPLATE__ from './audience-type-cell.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();